import ShopeeAnalyzer from './ShopeeAnalyzer';

function App() {
  return (
    <div className="App">
      <ShopeeAnalyzer />
    </div>
  );
}

export default App;